import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Layout } from '../components/Layout';
import { Skeleton } from '../components/ui/skeleton';
import { api } from '../lib/api';
import ToursDestination from './ToursDestination';
import TourDetail from './TourDetail';

// Resolves /tours/:slug into either a destination listing or a single tour detail.
export default function TourRoute() {
  const { slug } = useParams();
  const [kind, setKind] = useState(null); // 'destination' | 'tour' | 'none'

  useEffect(() => {
    setKind(null);
    api.tourResolve(slug).then(({ data }) => setKind(data.type)).catch(() => setKind('none'));
  }, [slug]);

  if (kind === null) return <Layout><div className="max-w-6xl mx-auto px-4 py-16"><Skeleton className="h-10 w-1/2 mb-4" /><Skeleton className="h-64 w-full rounded-2xl" /></div></Layout>;
  if (kind === 'destination') return <ToursDestination slug={slug} />;
  if (kind === 'tour') return <TourDetail slug={slug} />;
  return <Layout><div className="max-w-2xl mx-auto py-24 text-center"><p className="text-muted-foreground">Nothing found for “{slug}”.</p></div></Layout>;
}
